import styled from '@emotion/styled';
import { Link } from '@kc-console/common-ui';
import { getUserGuidePath } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import { useSearchPopover } from './SearchPopoverProvider';

const SearchGuide = () => {
  const { t } = useTranslation();
  const { inputValue } = useSearchPopover();
  const title = inputValue
    ? t('layout:search.guide.search_in_guide', { keyword: inputValue })
    : t('layout:search.guide.title');

  const href = inputValue ? `${getUserGuidePath('search')}?q=${inputValue}` : getUserGuidePath();

  return (
    <GuideLink href={href} external fullWidth>
      {title}
    </GuideLink>
  );
};

const GuideLink = styled(Link)`
  width: 100%;
  padding: 10px 20px;
  line-height: 22px;
  overflow-wrap: break-word;
  max-height: 280px;
  overflow-y: auto;
`;

export default SearchGuide;
